import type { Actor } from '@veem/crm-schema'
import { createSignal } from 'solid-js'
import type { Person } from '../prototype/data/people.ts'
import { api } from './api.ts'
import { disablePush } from './push.ts'

export interface Session {
  user: { id: string; name: string; email: string; role: Person['role'] }
  actor: Actor
  person: Person
}

export const [session, setSession] = createSignal<Session | null>(null)
export const readSession = () => api<Session | null>('/session')
export const signIn = (email: string, password: string) =>
  api('/session/sign-in', { method: 'POST', body: JSON.stringify({ email, password }) })
export const signOut = async () => {
  // A shared phone must not keep receiving the previous person's work.
  await disablePush().catch(() => {})
  await api('/session/sign-out', { method: 'POST', body: '{}' })
  setSession(null)
  window.location.reload()
}
